<template>
<div class="section">
  <div
      class="section-component"
      :class="{selectStyleElement: sec.isSelected === true}"
      v-for="(sec, index) in sections.values"
      :key="index"
      @click="handleSectionClick(index)"
  >
    <img class="image" :src="sec.src">
    <div
        class="section-component-text"
        :class="{selectedStyleElementText: sec.isSelected}"
    >
      {{ sec.text }}
    </div>
  </div>
</div>
</template>

<script setup>

import {defineEmits, reactive} from "vue";
const emit = defineEmits(['update:modelValue'])

const sections = reactive({
  values: [
    {
      text: "Полукруг",
      src: require("../../images/Sections/semicircle.svg"),
      isSelected: true
    },
    {
      text: "Прямоугольник",
      src: require("../../images/Sections/rectangle.svg"),
      isSelected: false
    },
    {
      text: "Круг",
      src: require("../../images/Sections/circle.svg"),
      isSelected: false
    },
    {
      text: "Треугольник",
      src: require("../../images/Sections/triangle.svg"),
      isSelected: false
    },
  ]
})

const handleSectionClick = (index) => {
  sections.values.forEach((section, ind) => {
    section.isSelected = (index === ind);
  });
  const section = sections.values.find(x => x.isSelected)
  emit('update:modelValue', section.text);
  // emit('sectionClick', section)
}

</script>

<style lang="scss" scoped>
.section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 50px;
  &-component {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(37, 37, 37, 0.75);
    height: 30px;
    width: 70px;
    border-radius: 15px;
    transition: 0.3s ease;
    &-text {
      position: absolute;
      color: white;
      bottom: -30px;
      font-size: 14px;
    }
  }
}
.image {
  height: 20px;
  width: 25px;
}
.selectStyleElement {
  background-color: rgb(101 95 95 / 53%) !important;
  transition: 0.3s ease;
}
.selectedStyleElementText {
  border: 1px solid white;
  border-radius: 35px;
  padding: 3px;
}
@media (max-width:420px) {
  .section-component-text {
    font-size: 12px;
  }
}
</style>